import intl from 'react-intl-universal'
import SERVER_INFO from 'config/server_info'
// import PatrolConfigIconWhite from 'components/images/icons/patrol_config_icon_white.svg'
import {FADefaultIcons} from 'utils/fontawesome'
import React from "react"

/*@@
  @Name: Endpoints
  @Description: Map to get link, icon and name code (localized)

  @Imports:
    import {Endpoints} from 'config/endpoints'

  @Usage
    Endpoints(i).name  #returns localized value
    Endpoints(i).icon
    Endpoints(i).to    // route
    Endpoint(i)

 */
const ENDPOINT_MAP = {
    LANDING:          {to: '/',                icon:'',      name: 'landing'},
    DASHBOARDS:           { icon:'threat_center', name: 'dashboards'},

    DASHBOARDS_COMPLIANCE_PROGRAM_MANAGER: {to: '/program_manager',  name: 'program_manager'},
    DASHBOARDS_COMPLIANCE_REVIEWER: {to: '/supervisor',  name: 'supervisor'},
    DASHBOARDS_SECURITY:        {to: '/dashboard',  name: 'security'},

    REVIEW_TASKS: {icon: 'assignment_turned_in', to: '/review_tasks',  name: 'review_tasks'},

    PATROL_CONTENT: {icon: 'assignment_turned_in', to: '/patrol_content',  name: 'patrol_content'},

    DASHBOARDS_DOMAIN_DISCOVER: {to: '/domain_discover',  name: 'domain_discover'},
    DASHBOARDS_DOMAIN_DISCOVER_DETAILS: {to: '/domain_discover/details/:id',  name: 'domain_discover_details'},
    PIVOT_REGISTRANT_EMAIL_ADDRESS: {to: '/domain_discover/whois/registrant_email/:id',  name: 'pivot'},

    CUSTOMER_SUPPORT: {to: '/customer_support',  name: 'customer_support'},

    DISCOVER:         { icon:'search',      name: 'discover'},
    DISCOVER_SOCIAL:      { name: 'social_discover_group_title'},
    DISCOVER_SOCIAL_NEW:      { icon:'search', name: 'social_discover'},
    DISCOVER_MOBILE_NEW:      { icon:'phone_android', name: 'mobile_discover'},
    DISCOVER_MOBILE:  { name: 'mobile_discover_group_title'},
    DISCOVER_DOMAIN:  { name: 'domain_discover_group_title'},
    DISCOVER_COMMON:  { name: 'common_discover_group_title'},

    DOMAIN_DISCOVER:  {icon:'language', to:'/domain_discover',  name:'domain_discover'},

    SYNDICATE:          {icon: 'settings_input_antenna',  name: 'syndicate'},
    SYNDICATE_CONTENT:  {to: `${SERVER_INFO.main_v1_path}/syndicate`,       icon:'',      name: 'syndicate_content'},
    SYNDICATE_CONFIG:   {to: `${SERVER_INFO.main_v1_path}/syndicate/config`,icon:'',      name: 'syndicate_config'},
    // SYNDICATE_USERS:    {to: `${SERVER_INFO.main_v1_path}/syndicate/users`, icon:'',      name: 'syndicate_users'},
    SYNDICATE_FEEDS:    {to: `${SERVER_INFO.main_v1_path}/syndicate/feeds`, icon:'',      name: 'syndicate_feeds'},

    LEGAL_FOOTER:  { to_privacy: `https://www.proofpoint.com/us/legal/privacy-policy`, to_terms: `https://www.proofpoint.com/us/legal/license`,  name: 'legal_footer'},

    //App switch  (THREAT and DASHBOARD)

    PATROL:           {/*to: '/patrol',*/          icon:'patrol',        name: 'patrol'},

    //Content classifier audit app
    PATROL_INCIDENTS: {to: '/patrol/incidents', icon:'syndicate', name: 'content_and_incidents'},
    PATROL_ITEM: {to: '/patrol/items/:id', icon:'syndicate', name: 'content_item'},

    BASE_v1:        {to: `${SERVER_INFO.main_v1_path}`,              icon:'',      name: 'base_v1'},

    PATROL_ACCOUNT:       { href: `${SERVER_INFO.main_v1_path}/patrol/accounts/%ACCOUNTID%?new_tab=true`,      name: 'patrol_account'},

    NOTIFICATION:       { href: `${SERVER_INFO.main_v1_path}/v2/email_notifications/%NOTIFICATIONID%/details`,      name: 'notification'},

    //Support customers
    SET_SUPPORT_CUSTOMER: { href: `${SERVER_INFO.main_v1_path}/users/support_sign_in`,      name: 'set_support_customer'},

    //Video
    DOWNLOAD_VIDEO:       { href: `${SERVER_INFO.main_v1_path}/patrol/items/%ITEMID%/download_video`,      name: 'download_video'},
    DOWNLOAD_TRANSCRIPT:  { href: `${SERVER_INFO.main_v1_path}/patrol/items/%ITEMID%/download_transcript`, name: 'download_transcript'},
    DOWNLOAD_VIDEO_AND_TRANSCRIPT: {href: `${SERVER_INFO.main_v1_path}/patrol/items/%ITEMID%/download_video_and_transcript`, name:'download_video_and_transcript'},

    //Audio
    DOWNLOAD_AUDIO:       { href: `${SERVER_INFO.main_v1_path}/patrol/items/%ITEMID%/download_audio`,      name: 'download_audio'},
    DOWNLOAD_AUDIO_AND_TRANSCRIPT: {href: `${SERVER_INFO.main_v1_path}/patrol/items/%ITEMID%/download_audio_and_transcript`, name:'download_audio_and_transcript'},

    // Attachments (V2)
    ATTACHMENT_DOWNLOAD_BUNDLE: { href: `${SERVER_INFO.main_v1_path}/v2/content_items/attachments/%ITEMID%/%ATTACHMENTID%/download_bundle`, name: 'attachment_download_bundle' },

    //File
    DOWNLOAD_CONTENT:     { href: `${SERVER_INFO.main_v1_path}/patrol/items/%ITEMID%/download_content`,      name: 'download_content'},
    DOWNLOAD_BREACH_EMAIL_ADDRESSES:     { href: `${SERVER_INFO.main_v1_path}/patrol/items/%ITEMID%/download_breach_email_addresses_v2`,      name: 'download_breach_email_addresses'},
    DOWNLOAD_DARKNET_CREDIT_CARDS: {href:`${SERVER_INFO.main_v1_path}/patrol/items/%ITEMID%/download_matching_credit_cards`,      name: 'download_darknet_credit_cards'},

    //Item /Submitted Content Item actions
    ADD_CONTENT_CONTEXT:      { href: `${SERVER_INFO.main_v1_path}/v2/patrol_content/add_content_context`,                    name: 'add_content_context'},
    APPROVE_ITEM:             { href: `${SERVER_INFO.main_v1_path}/dashboard/workflow/%CONTENTCONTEXTID%/v2_approve`,         name: 'approve_item'},
    GLOBALLY_APPROVE_ITEM:    { href: `${SERVER_INFO.main_v1_path}/dashboard/workflow/%CONTENTCONTEXTID%/v2_globally_approve`, name: 'globally_approve_item'},
    REVIEW_ITEM:              { href: `${SERVER_INFO.main_v1_path}/dashboard/workflow/%CONTENTCONTEXTID%/v2_review`,          name: 'review_item'},
    REJECT_ITEM:              { href: `${SERVER_INFO.main_v1_path}/dashboard/workflow/%CONTENTCONTEXTID%/v2_reject`,          name: 'reject_item'},
    FORWARD_ITEM:             { href: `${SERVER_INFO.main_v1_path}/dashboard/workflow/%CONTENTCONTEXTID%/v2_forward`,         name: 'forward_item'},
    PERMANENTLY_MASK_CONTENT_ITEM: { href: `${SERVER_INFO.main_v1_path}/v2/review_tasks/permanently_mask_content`, name: 'permanently_mask_content_item' },
    APPROVE_AND_FORWARD_ITEM: { href: `${SERVER_INFO.main_v1_path}/dashboard/workflow/%CONTENTCONTEXTID%/v2_approve_forward`, name: 'approve_and_forward_item'},
    PREVIOUS_VERSIONS_NOTES:  { href: `${SERVER_INFO.main_v1_path}/v2/content_items/previous_versions/previous_notes/%ITEMID%`, name: 'previous_notes'},

    //It may be cleaner to change endpoints to /content_contents/999 and /accounts/999
    RETRIEVE_CONTENT_NOTES:    { href: `${SERVER_INFO.main_v1_path}/v2/items/%CONTENTCONTEXTID%/retrieve_notes`,  name: 'retrieve_content_notes'},
    ADD_CONTENT_NOTE:          { href: `${SERVER_INFO.main_v1_path}/v2/items/%CONTENTCONTEXTID%/add_note`,  name: 'add_content_note'},
    RETRIEVE_ITEM_SHARING_INFO:{ href: `${SERVER_INFO.main_v1_path}/v2/items/%ACCOUNTID%/retrieve_sharing_info`,  name: 'retrieve_sharing_info'},
    SHARE_CONTENT:{ href: `${SERVER_INFO.main_v1_path}/v2/items/%ITEMID%/share_content`,  name: 'share_content'},
    TASK_ASSIGN:{ href: `${SERVER_INFO.main_v1_path}/v2/items/%CONTENTCONTEXTID%/task_assign`,  name: 'task_assign'},
    PROFILE_TASK_ASSIGN:{ href: `${SERVER_INFO.main_v1_path}/v2/review_tasks/%TASKID%/profile_task_assign`,  name: 'task_assign'},

    PROFILE_SNAPSHOTS:{ href: `${SERVER_INFO.main_v1_path}/v2/review_tasks/participant_accounts_snapshots`,  name: 'task_assign'},
    PROFILE_EXPORT:{ href: `${SERVER_INFO.main_v1_path}/v2/profile_export`, name: 'profile_export'},

    TASK_ASSIGNMENT_USERS:{ href: `${SERVER_INFO.main_v1_path}/v2/patrol/task_assignment_users`,  name: 'task_assignment_users'},
    TASK_LIST_ATTRIBUTES:{ href: `${SERVER_INFO.main_v1_path}/v2/review_tasks/task_list_attributes`,  name: 'task_list_attributes'},

    REVIEWER_ATTACHMENTS: {to: `${SERVER_INFO.main_v1_path}/v2/review_tasks/reviewer_attachments/:id`, name: 'reviewer_attachments'},

    REDIRECT_TO_PROFILE_REVIEW: {href: `${SERVER_INFO.main_v1_path}/patrol/profile_reviews`, name: 'redirect_to_profile_review' },

    //Demo
    THREAT_v1:           {href: `${SERVER_INFO.main_v1_path}/dashboard`,       icon:'threat_center', name: 'dashboard'},
    DISCOVER_v1:         {href: `${SERVER_INFO.main_v1_path}/domain_discover`, icon:'discover' ,     name: 'discover'},
    PATROL_v1:           {href: `${SERVER_INFO.main_v1_path}/patrol`,          icon:'patrol',        name: 'patrol'},
    SIGHT_v1:            {href: `${SERVER_INFO.main_v1_path}/syndicate`,       icon:'syndicate',     name: 'sight'},

    USER_NOTIFICATIONS:{to: '/dashboard/user_notifications', icon:'',      name: 'user_notifications'},

    // management
    USER_MANAGEMENT:  {to: '/user_management',               icon:'',      name: 'user_management'},

    // tenant_management
    SUBTENANT_MANAGEMENT:  {to: '/subtenant_management',icon:'',name: 'subtenant_management'},

    //message_exclusion_rules
    MESSAGE_EXCLUSION_RULES:  {to: '/message_exclusion_rules',icon:'',name: 'message_exclusion_rules'},

    //manage_teams
    MANAGE_TEAMS:  {to: '/manage_teams',icon:'',name: 'manage_teams'},

    EXTERNAL_APPS:    {to: '/management/external_apps', icon:'',      name: 'external_apps'},
    AUDIT_LOGS:       {to: '/audit_logs',                icon:'',      name: 'audit_logs'},

    // admin management
    ADMIN_ACCOUNT:        {to: `${SERVER_INFO.main_v1_path}/account`,              icon:'',      name: 'admin_account'},
    ADMIN_SETTINGS:       {to: '/admin_settings',                                                name: 'admin_settings'},
    GLOBAL_SETTINGS:      {to: '/global_settings',                                               name: 'global_settings'},
    ADMIN_CLIENTS:        {to: `${SERVER_INFO.main_v1_path}/admin/clients`,        icon:'',      name: 'admin_clients'},
    ADMIN_USERS:          {to: `${SERVER_INFO.main_v1_path}/admin/users`,          icon:'',      name: 'admin_users'},
    ADMIN_ROLES:          {to: `${SERVER_INFO.main_v1_path}/admin/roles`,          icon:'',      name: 'admin_roles'},
    ADMIN_TEAMS:          {to: `${SERVER_INFO.main_v1_path}/admin/teams`,          icon:'',      name: 'admin_teams'},
    ADMIN_EXTERNAL_APPS:  {to: `${SERVER_INFO.main_v1_path}/admin/external_apps`,  icon:'',      name: 'admin_external_apps'},
    ADMIN_TAKEDOWNS:      {to: `${SERVER_INFO.main_v1_path}/admin/takedowns`,      icon:'',      name: 'admin_takedowns'},
    ADMIN_AUDITS:         {to: `/audit_logs`,         icon:'',      name: 'admin_audits'},

    // help
    HELP_DESK:        {to: '/support/help_desk',     icon:'',      name: 'help_desk'},
    DOCUMENTATION:    {to: '/support/documentation', icon:'',      name: 'documentation'},
    PROOFPOINT_SUPPORT: {to: `https://proofpointcommunities.force.com/community/s/digital-risk`, icon:'',      name: 'support'},

    SUPPORT_PORTAL: {to: `https://proofpointcommunities.force.com/community/s/digital-risk`, icon:'', name: 'support_portal', open_new: true},
    CLASSIFIER_DOCUMENTATION: { to: `${SERVER_INFO.main_v1_path}/patrol/mind_touch_redirect/classifier_definition`,  name: 'classifier_documentation', open_new: true},
    GENERAL_DOCUMENTATION: { to: `${SERVER_INFO.main_v1_path}/patrol/mind_touch_redirect/general_documentation`,  name: 'general_documentation', open_new: true},
    PROOFPOINT_RADAR: { to: `${SERVER_INFO.main_v1_path}/patrol/mind_touch_redirect/proofpoint_radar`,  name: 'proofpoint_radar', open_new: true},
    DEVELOPER_DOC: { to: `${SERVER_INFO.main_v1_path}/patrol/mind_touch_redirect/developer_doc`,  name: 'developer_doc', open_new: true},
    EFD_SUPPORT_PORTAL: {to: `https://proofpointcommunities.force.com/community/s/email-fraud-defense`, name: 'efd_support_portal', open_new: true},

    MARKDOWN_INSTRUCTIONS: {to: `https://daringfireball.net/projects/markdown/basics`, name: 'efd_support_portal', open_new: true},

    // PMv3 Documentation
    COMPLIANCE_FORMAT_LINK: { to:"https://help.proofpoint.com/DigitalRisk/Documentation/Profile_Features", name: 'compliance_format_doc'},
    MULTI_TIER_LINK: { to: "https://help.proofpoint.com/DigitalRisk/Documentation/Profile_Features", name: 'edit_with_loopback_doc'},
    SUSPICIOUS_ACTIVITY_LINK: { to: "https://help.proofpoint.com/DigitalRisk/Documentation/Profile_Features", name: 'suspicious_activity_doc'},

    //user
    USER_SETTINGS:    {to: '/user_settings/settings',icon:'',      name: 'user_settings'},
    SIGN_OUT:         {href: `${SERVER_INFO.main_v1_path}/users/sign_out`, to:`${SERVER_INFO.main_v1_path}/users/sign_out`, icon:'', name: 'sign_out'},
    //registration
    REGISTER:         {to: '/register', icon:'',      name: 'register'},
    SIGN_IN:          {to: '/sign_in',  icon:'',      name: 'sign_in'},
    //Accounts
    ACCOUNTS:         {to: '/management/accounts', icon:'',      name: 'accounts'},

    PROOFPOINT_SIGN_IN: {to:  `${SERVER_INFO.main_v2_path}/sign_in`, icon:'',      name: 'proofpoint_sign_in'},
    LOGIN_PASSWORD_RESET: {to: '/forgot_password', name: 'login_password_reset'},
    LOGIN_ONELOGIN: {to: 'https://app.onelogin.com/client/apps', name: 'login_onelogin'},

    SOCIAL_IDENTITY_SEARCHES:     {to: '', icon:'people',         name: 'social_identity_searches'},
    SOCIAL_ACCOUNTS:              {to: '', icon:'account_box',    name: 'protected_assets_social_accounts'},
    DOMAIN_IDENTITY_SEARCHES:     {to: '', icon:'language',       name: 'domain_identity_searches'},
    DOMAIN_IDENTITY_SEARCHES_V2:  {to: '', icon:'language',       name: 'domain_identity_searches'},
    PEOPLE:                       {to: '', icon:'person',         name: 'entities_people'},
    PLACE:                        {to: '', icon:'place',          name: 'locations'},
    MOBILE_APP_IDENTITY_SEARCHES: {to: '', icon:'smartphone',     name: 'mobile_app_identity_searches'},
    BRAND:                        {to: '', icon:'loyalty',        name: 'brands'},
    CUSTOM:                       {to: '', icon:'tune',           name: 'custom'},

    //Catalog
    CATALOG:                      {to: '/demo/catalog',   icon:'',      name: 'catalog'},

    //Sandboxed Dashboard
    SANDBOX_DASHBOARD:            {to: '/sandbox_dashboard',  icon:'',      name: 'dashboard'},
    SANDBOX_USER_NOTIFICATIONS:   {to: '/sandbox_dashboard/user_notifications', icon:'',      name: 'user_notifications'},



    //V1

    // Download files
    CUSTOMER_FILE_DOWNLOAD:      { href: `${SERVER_INFO.main_v1_path}/customer_file/`, name: 'customer_file'},
    CUSTOMER_REPORT_CSV_DOWNLOAD:      { href: `${SERVER_INFO.main_v1_path}/dashboard/report_runs/%REPORTID%/csv`, name: 'customer_file'},

    CUSTOMER_FILE_BIN_DOWNLOAD:      { href: `${SERVER_INFO.main_v1_path}/customer_file/bin_content/`, name: 'customer_file_bin'},

    CUSTOMER_FILE_TAKEDOWN_EVIDENCE_DOWNLOAD:      { href: `${SERVER_INFO.main_v1_path}/customer_file/takedown_evidence/`, name: 'customer_file_takedown_evidence'},

    CUSTOMER_FILE_UPLOAD:        { to: `${SERVER_INFO.main_v1_path}/v2/customer_file/`, name: 'customer_file_upload'},

  //Discover Common
    DISCOVER_COMMON_IMAGE_LIBRARY:      { href: `${SERVER_INFO.main_v1_path}/discover_common/image_library`, /*icon: 'collections',*/ name: 'image_library'},

    DISCOVER_COMMON_IMAGE_LIBRARY_NEW:      { href: `${SERVER_INFO.main_v1_path}/discover_common/image_library`, icon: 'photo_library', name: 'image_libraries'},

    //Social Discover
    DISCOVER_SOCIAL_FIND_ACCOUNTS:      { href: `${SERVER_INFO.main_v1_path}/discover`, params: {s:true}, name: 'find_accounts', icon: ''},
    DISCOVER_SOCIAL_ADVANCED_DISCOVER:  { href: `${SERVER_INFO.main_v1_path}/discover/advanced_discovers`, name: 'advanced_discover'},
    DISCOVER_SOCIAL_ADD_ACCOUNTS:       { href: `${SERVER_INFO.main_v1_path}/discover/accounts`, name: 'add_accounts'},
    DISCOVER_SOCIAL_TAG_VIEW:           { href: `${SERVER_INFO.main_v1_path}/discover/tags`, name: 'tag_view'},
    DISCOVER_SOCIAL_IGNORED_ACCOUNTS:   { href: `${SERVER_INFO.main_v1_path}/discover/ignored`, name: 'ignored_accounts'},

    DISCOVER_INSTALL: { href: `${SERVER_INFO.main_v1_path}/discover/install`, name: 'install_discover_account'},
    DISCOVER_UNINSTALL: { href: `${SERVER_INFO.main_v1_path}/discover/uninstall`, name: 'uninstall_discover_account'},

    //Mobile Discover
    DISCOVER_MOBILE_FIND_APPS:          { href: `${SERVER_INFO.main_v1_path}/mobile_discover`, params: {s:true}, name: 'find_apps'},
    DISCOVER_MOBILE_TAG_VIEW:           { href: `${SERVER_INFO.main_v1_path}/mobile_discover/tags`, name: 'tag_view'},
    DISCOVER_MOBILE_IGNORED_APPS:       { href: `${SERVER_INFO.main_v1_path}/mobile_discover/ignored_mobile_apps`, name: 'ignored_apps'},

    //Domain Discover
    DISCOVER_DOMAIN_CONFIG:           { href: `${SERVER_INFO.main_v1_path}/web_discover/config`, name: 'configuration'},
    DISCOVER_DOMAIN_DETECTIONS:       { href: `${SERVER_INFO.main_v1_path}/web_discover/tags`, name: 'domain_detections'},

    DISCOVER_DOMAIN_CONFIG_V2:        { href: '/domain_discover', to: '/domain_discover', name: 'configuration_v2', params: {tab:'seeds'}},
    DISCOVER_DOMAIN_DETECTIONS_V2:    { href: '/domain_discover', to: '/domain_discover', name: 'domain_detections_v2'},

    DISCOVER_DOMAIN_URLS_TAGS:        { href: `${SERVER_INFO.main_v1_path}/web_discover/tags_urls`, name: 'url_detections'},
    DISCOVER_DOMAIN_ADD_WATCHED:      { href: `${SERVER_INFO.main_v1_path}/web_discover/domains`, name: 'add_watched'},
    DISCOVER_DOMAIN_IGNORED_DOMAINS:  { href: `${SERVER_INFO.main_v1_path}/web_discover/ignored`, name: 'ignored_domains'},
    DISCOVER_DOMAIN_ALERTS:           { href: `${SERVER_INFO.main_v1_path}/web_discover/domain_alerts`, name: 'alerts_v1'},

    // PATROL:
    PATROL_ENTITIES:                  { href: `${SERVER_INFO.main_v1_path}/patrol`,  params: {list_type: 'protected'}, name: 'policy_configuration_page'},
    PATROL_ENTITIES_EXPIRED:          { href: `${SERVER_INFO.main_v1_path}/patrol`,  params: {list_type: 'expired'}, name: 'entities_expired'},
    PATROL_ENTITIES_UNPROTECTED:      { href: `${SERVER_INFO.main_v1_path}/patrol`,  params: {list_type: 'unprotected'}, name: 'entities_unprotected'},
    PATROL_ENTITIES_PLACE:            { href: `${SERVER_INFO.main_v1_path}/patrol`,  params: {list_type: 'place'},  name: 'entities_places'},
    PATROL_ENTITIES_PEOPLE:           { href: `${SERVER_INFO.main_v1_path}/patrol`,  params: {list_type: 'people'}, name: 'entities_people'},
    PATROL_ENTITIES_BRAND:            { href: `${SERVER_INFO.main_v1_path}/patrol`,  params: {list_type: 'brand'},  name: 'entities_brand'},
    PATROL_ENTITIES_CUSTOM:           { href: `${SERVER_INFO.main_v1_path}/patrol`,  params: {list_type: 'hashtag'}, name: 'entities_hastag'},
    PATROL_PROFILES:                  { href: `${SERVER_INFO.main_v1_path}/patrol/profile_reviews`, name: 'profiles'},
    PATROL_CONTENT_INCIDENTS:         { href: `${SERVER_INFO.main_v1_path}/patrol/incidents`, name: 'content_and_incidents'},
    PATROL_CONTENT_ITEM:              { href: `${SERVER_INFO.main_v1_path}/patrol/incidents`, name: 'content_item'},
    PATROL_ACCOUNT_ADMINS:            { href: `${SERVER_INFO.main_v1_path}/patrol/access`, name: 'account_admins'},
    PATROL_APP_POLICIES:              { href: `${SERVER_INFO.main_v1_path}/patrol/applications`, name: 'app_policies'},
    PATROL_APP_POLICIES_V2:           { to: '/app_policies', name: 'app_policies_v2' },
    // TODO: Delete after 2603 release
    // PATROL_CONTENT_POLICIES:          { href: `${SERVER_INFO.main_v1_path}/patrol/policies`, name: 'content_policies'},
    PATROL_CONTENT_POLICIES:          { to: '/content_policies', name: 'content_policies' },
    // TODO: Delete after 2603 release
    // PATROL_CONTENT_POLICIES_V2:       { to: '/content_policies', name: 'content_policies_v2' },
    PATROL_CUSTOM_POLICIES:           { href: `${SERVER_INFO.main_v1_path}/patrol/custom`, name: 'custom_policies'},
    PATROL_PROFILE_POLICIES:          { href: `${SERVER_INFO.main_v1_path}/patrol/profile_policies`, name: 'profile_policies'},
    PATROL_ACCESS_POLICIES:           {to: '/patrol/access',  name: 'proxy_access_policy_title'},
    PATROL_COMMENTERS:                { to: '/commenters', name: 'commenters' },
    PATROL_CONFIGURATION:             { href: `${SERVER_INFO.main_v1_path}/patrol/config`, name: 'configuration'},
    PATROL_CLASSIFIER_AUDIT_REPORT:   {to: '/content_classifier_audit',  name: 'classifier_audit_report'},

    SOCIAL_ACCOUNT_INSTALL: { href: `${SERVER_INFO.main_v1_path}/patrol/install`, name: 'configuration'},
    BRAND_INSTALL:          { href: `${SERVER_INFO.main_v1_path}/patrol/install/brand_entity`, name: 'configuration'},
    TERM_INSTALL:           { href: `${SERVER_INFO.main_v1_path}/patrol/install/hashtag_account`, name: 'configuration'},
    PEOPLE_INSTALL:         { href: `${SERVER_INFO.main_v1_path}/patrol/install/people_protect`, name: 'configuration'},
    PLACE_INSTALL:          { href: `${SERVER_INFO.main_v1_path}/patrol/install/place_account`, name: 'configuration'},

    PATROL_MARKETING_EMAIL_CONTENT:   { href: `/iframe_wrapper/retrieve_mea_content/%ITEMID%`,  name: 'mea_content_html'},

    PATROL_ACCOUNT_INSTALL:          { href: `${SERVER_INFO.main_v1_path}/patrol/accounts/%ACCOUNTID%/install`, name: 'account_install'},

    // CONNECTORS:
    CONNECTOR_CONFIGURATION:          {to: '/connector_configuration', icon:'settings_input_component',  name: 'connector_configuration'},
    CONNECTOR_CONFIGURATION_INSTALL:  {to:  `${SERVER_INFO.main_v1_path}/v2/connector`, name: 'connector_config_install'},
    CONNECTOR_CONFIGURATION_SUCCESS:  {to:  `${SERVER_INFO.main_v1_path}/install_connector`, name: 'connector_config_success'},
    TEAMS_CERTIFICATE:                { href: `${SERVER_INFO.main_v1_path}/v2/connector_certificate`, name: 'teams_certificate'},

    //REPORTS
    REPORTS:                          { href: `${SERVER_INFO.main_v1_path}/dashboard/reports`, icon: 'library_books', name: 'reports'},

    CATEGORY_REFERENCE:               { href: `${SERVER_INFO.main_v1_path}/patrol/mind_touch_redirect/classifier_definition`,  name: 'category_reference'},

    CPUM_CSV_UPLOAD:                 { to: `${SERVER_INFO.main_v1_path}/v2/participants/cpum_csv_upload`, name: 'cpum_csv_upload'},

    // PATROL CONFIGURATIONS <img src={PatrolConfigIconWhite}/>
    PATROL_CONFIGURATIONS:           { icon:  FADefaultIcons.CONFIG.PATROL_CONFIG.icon,  name: 'patrol_configurations'},
    REVIEW_CONFIGURATION:            { to: '/review_configuration', icon:'', name: 'review_configuration'},
    ARCHIVE_CONFIG:                  { to: '/archive_config', icon:'', name: 'archive_configuration'},
    CONTENT_NOTIFICATIONS:           { to: '/content_notifications', icon:'', name: 'content_notifications'},
    INSTALL_OVERVIEW_PAGES:          { to: '/install_overview_pages', icon:'', name: 'install_overview_pages'},
    PATROL_PROFILE_POLICIES_V3:      { to: '/profile_policies', name: 'profile_policies_v3'},
    PATROL_ENTITIES_V2:              { to: '/patrol_accounts', name: 'patrol_entities_v2'},
    ACTIVITY_POLICIES:              { to: '/activity_policies', name: 'granular_activity_policies'},
    NOTIFICATIONS:                  { to: '/notifications', name: 'account_owner_notifications'},

    PRE_REVIEW:                      { to: '/profile_submission', name: 'profile_submission'},
    FULL_PRE_REVIEW:                 { href: `${SERVER_INFO.main_v2_path}/profile_submission`, name: 'profile_submission'},
    PRE_REVIEW_SIGN_IN_FB:           { href: `${SERVER_INFO.main_v1_path}/prereview/connect/FB?pmv3=true`, name: 'pre_review_sign_in_FB'},
    PRE_REVIEW_SIGN_IN_LI:           { href: `${SERVER_INFO.main_v1_path}/prereview/connect/LI?pmv3=true`, name: 'pre_review_sign_in_LI'},
    PRE_REVIEW_SIGN_IN_TW:           { href: `${SERVER_INFO.main_v1_path}/prereview/connect/TW?pmv3=true`, name: 'pre_review_sign_in_TW'},
    PRE_REVIEW_SIGN_IN_GB:           { href: `${SERVER_INFO.main_v1_path}/prereview/connect/GB?pmv3=true`, name: 'pre_review_sign_in_GB'},

    PATROL_INSTALL:                  { to: '/patrol_install', name: 'patrol_install'},
    V1_TOKEN_PATROL_INSTALLATION:    { href: `${SERVER_INFO.main_v1_path}/install_patrol/:token`, name: 'v1_token_install_patrol'},
    V1_PATROL_INSTALLATION:          { href: `${SERVER_INFO.main_v1_path}/patrol/install`, name: 'v1_install_patrol'},

    // PROFILE_MANAGER
    PROFILE_MANAGER_IMAGES_BASE: { href: `${SERVER_INFO.main_v1_path}/v2/profile_manager/profile_lock_image/`,  name: 'profile_manager_images_base'},

    // DEV SANDBOX
    _SANDBOX: { to: '/_sandbox', name: 'sandbox'},

}

const Endpoints = (end) => {
    if (ENDPOINT_MAP.hasOwnProperty(end)) {
        return (() => {
            return {...ENDPOINT_MAP[end], name: intl.get(ENDPOINT_MAP[end].name), code: end}
        })()
    } else {
        return {to: '/404'}     //TODO
    }
}

export  {Endpoints, ENDPOINT_MAP}  //Convenience for tests
